import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RafiqChatBot, {
  getRafiqUserToolChatOptions,
  isLoggedInStudentUser,
} from "./RafiqChatBot";
import botImage from "../../assets/images/bot.png";
import { storageHelper } from "../../Helpers/storageHelper";
import { handleAIMessage } from "../../Helpers/AIHelper";

const HOME_CHAT_BASE_OPTIONS = [
  { text: "خدماتنا", value: "services" },
  { text: "معلومات عن الموقع", value: "info" },
  { text: "الأسعار", value: "pricing" },
  { text: "من نحن", value: "about" },
];

const GlobalRafiqChatBot = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const isAuthenticated = !!storageHelper.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();


  const initialChatOptions = React.useMemo(() => {
    if (isLoggedInStudentUser()) {
      return [...HOME_CHAT_BASE_OPTIONS, ...getRafiqUserToolChatOptions()];
    }
    return HOME_CHAT_BASE_OPTIONS;
  }, [isAuthenticated]);

  // Hide on specific routes
  const hideOnRoutes = [
    '/teacher/dashboard',
    '/teacher/exams/details',
    '/teacher/students/view',
    '/teacher/courses/videos'
  ];

  if (hideOnRoutes.some(route => location.pathname.startsWith(route))) {
    return null;
  }

  const handleChatOptionSelect = async (option) => {
    switch (option.value) {
      case 'services':
        navigate('/services');
        return { message: "تفضل باستعراض خدماتنا المميزة." };
      case 'pricing':
        navigate('/pricing');
        return { message: "إليك خطط الأسعار المتوفرة." };
      case 'about':
        navigate('/about');
        return { message: "تعرف علينا أكثر." };
      case 'courses':
        navigate('/services?tab=courses');
        return { message: "إليك دوراتنا التدريبية المتاحة." };
      case 'exams':
        navigate('/services?tab=exams');
        return { message: "إليك خدمات الامتحانات." };
      case 'blogs':
        navigate('/services?tab=blogs');
        return { message: "استكشف أحدث المقالات والمدونات." };
      case 'info':
        return {
          message: "منصة امتحاني هي منصة تعليمية متكاملة تهدف لتوفير بيئة تعليمية آمنة وذكية للطلاب والمعلمين. نقدم خدمات الامتحانات، المدونات، والدورات التدريبية بمميزات فريدة.",
          nextOptions: initialChatOptions
        };
      case 'back':
        return {
          message: "كيف يمكنني مساعدتك؟",
          nextOptions: initialChatOptions
        };
      case 'rafiq_self_exam':
        navigate('/student/self-exam');
        return { message: "جاري فتح اختبار رفيق الذكي..." };
      case 'rafiq_zatouna':
        navigate('/zatouna');
        return { message: "جاري فتح أداة الزتونة..." };
      case 'rafiq_zakerly':
        navigate('/zakerly');
        return { message: "جاري فتح ذاكرلي..." };
      case 'rafiq_story_learn':
        navigate('/story-learn');
        return { message: "جاري فتح تعلم بالقصة..." };
      default:
        return null;
    }
  };

  return (
    <>
      <style jsx>{`
        .rafiq-chat-trigger {
          position: fixed;
          bottom: 24px;
          right: 24px;
          width: 64px;
          height: 64px;
          border-radius: 50%;
          background: #ffffff;
          border: 1px solid #E2E8F0;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          transition: all 0.25s ease;
          animation: float 3.2s ease-in-out infinite;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }

        .rafiq-chat-trigger:hover {
          transform: scale(1.08) rotate(-4deg);
          box-shadow: 0 18px 34px rgba(0, 0, 0, 0.12);
          border-color: #6366f1;
        }

        .rafiq-chat-trigger img {
          width: 42px;
          height: 42px;
          object-fit: contain;
        }

        .notification-badge {
          position: absolute;
          top: -2px;
          left: -2px;
          background: #6366f1;
          color: white;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
          font-weight: bold;
          box-shadow: 0 4px 8px rgba(245, 158, 11, 0.3);
        }

        @media (max-width: 768px) {
          .rafiq-chat-trigger {
            width: 58px;
            height: 58px;
            right: 16px;
            bottom: 16px;
          }

          .rafiq-chat-trigger img {
            width: 38px;
            height: 38px;
          }
        }
      `}</style>

      <button
        className="rafiq-chat-trigger"
        onClick={() => setIsChatOpen(true)}
        title="تحدث مع رفيق"
      >
        <img src={botImage} alt="رفيق" />
        <span className="notification-badge">1</span>
      </button>

      <RafiqChatBot
        isOpen={isChatOpen}
        onClose={() => setIsChatOpen(false)}
        options={initialChatOptions}
        onOptionSelect={handleChatOptionSelect}
        onAIMessage={(input, history) => handleAIMessage(input, history, initialChatOptions)}
        enableChat={false}
        welcomeMessage="مرحباً بك في منصة امتحاني! أنا رفيق، مساعدك الذكي. كيف يمكنني مساعدتك اليوم؟"
      />
    </>
  );
};

export default GlobalRafiqChatBot;
